import { withStyles, makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';

export const TakisCard = withStyles(theme => ({
  root: {
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: theme.palette.purple
  },
}))(Card);

export const useStyles = makeStyles(theme => ({
  recipeList: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: theme.palette.yellow,
    paddingBottom: "8rem",
  },
  title: {
    color: theme.palette.purple,
    marginBottom: "1.5rem",
    fontSize: '3.8rem'
  },
  recipesContainer: {
    marginBottom: "2.5rem",
    maxWidth: "20rem",
    [theme.breakpoints.up('sm')]: {
      maxWidth: "21.375rem",
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: "33rem",
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: "60rem",
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: "82rem",
    }
  },
  recipe: {
    background: theme.palette.purple,
    width: "100%",
    borderRadius: "0"
  },
  recipeContent: {
    padding: "1rem",
    "&:last-child": {
      paddingBottom: "1rem"
    }
  },
  recipeTitle: {
    fontSize: "2.5rem",
    color: theme.palette.yellow,
    height: "auto",
    textTransform: "uppercase"
  },
  imageContainer: {
    position: "relative",
    paddingBottom: "10rem",
    [theme.breakpoints.up('md')]: {
      paddingBottom: "16rem",
    },
    [theme.breakpoints.up('lg')]: {
      paddingBottom: "14rem",
    },
    [theme.breakpoints.up('xl')]: {
      paddingBottom: "20rem",
    }
  },
  image: {
    position: "absolute",
    top: "0",
    width: "100%",
    '& img': {
      padding: "0.5rem 0.5rem 0"
    },
  },
  recipeCta: {
    fontSize: "2rem",
    color: theme.palette.white,
    position: 'relative'
  },
  recipeCtaIcon: {
    width: "1.2rem",
    marginLeft: "0.5rem"
  },
  button: {
    boxShadow: 'none',
    textTransform: 'none',
    height: '4.375rem',
    padding: '0.938rem',
    fontSize: '2.5rem',
    fontFamily: 'Veneer, Arial',
    margin: '0.625rem',
    borderRadius: 0,
    backgroundColor: theme.palette.yellow,
    color: theme.palette.purple,
    borderColor: theme.palette.purple,
    borderStyle: 'solid',
    borderWidth: '0.313rem',
    lineHeight: 1.5,
    '&:hover': {
      backgroundColor: theme.palette.whiteTransparent,
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: theme.palette.white,
      outlineWidth: '0.313rem',
      outlineStyle: 'solid',
      outlineColor: theme.palette.white,
    },
  }
}));
